module.exports = __webpack_public_path__ + "static/media/7ce0a2f5-eb00-46aa-919c-5b3f3667646c.d856c139.woff2";